export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/example-food-layer-3.afcb6273-f633b3.png";